import React from 'react'
import {
  IconButton, Paper, Grid, Button,
  TextField, OutlinedInput, InputLabel,
  FormControl, InputAdornment,
  makeStyles, Theme, createStyles,
  Dialog, DialogActions, DialogContent,
  DialogTitle, DialogContentText, FormHelperText,
  CircularProgress,
  Typography
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { green } from '@material-ui/core/colors';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { typeUserInfo } from '../../../api/helpline/user'


interface Prop {
  userInfo: typeUserInfo | undefined,
  form: {
    currentpassword: string,
    changepassword: string,
    checkpassword: string,
  },
  show: {
    current: boolean,
    change: boolean,
    check: boolean,
  },
  open: boolean,
  loading: boolean,
  passwordc: boolean,
  errmsg: string,
  handleClickOpen: () => void,
  handleClose: () => void,
  handleChangeForm: (event: React.ChangeEvent<{
    value: unknown;
    name?: string | undefined;
  }>) => void,
  onSubmit: () => void,
  handleClickCurrentPassword: () => void,
  handleClickChangePassword: () => void,
  handleClickCheckPassword: () => void,
  handleMouseDownPassword: (event: React.MouseEvent<HTMLButtonElement>) => void,
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '80%'
    },
    form: {
      margin: theme.spacing(2),
      padding: theme.spacing(1),
    },
    mWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "80%",
      minWidth: "40%"
    },
    lWidth: {
      marginTop: theme.spacing(1),
      width: "100%",
    },
    chips: {
      marginTop: theme.spacing(1),
      marginLeft: theme.spacing(1),
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    dialogtitle: {
      display: 'flex',
      alignItems: 'center',
      color: 'red',
    }
  }),
);



const PasswordSettingForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { userInfo, loading, form, handleChangeForm, handleClickCurrentPassword,
    handleClickChangePassword, handleClickCheckPassword, handleMouseDownPassword, show, open, handleClickOpen, handleClose, onSubmit, passwordc, errmsg } = props
  const checkLength = form.changepassword.length * form.checkpassword.length * form.currentpassword.length === 0
  const checkChange = form.changepassword !== form.checkpassword
  // const checkCurrent = form.currentpassword !== passWord
  const allCheck = checkLength ? true : checkChange ? true : loading ? true : passwordc ? true : false
  return (
    <React.Fragment>
      <form className={classes.form}>
        <Grid container direction="row" justify="center" alignItems="center">
          <Paper elevation={0} className={classes.paper}>
            <Grid item xs={12}>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <TextField id="userName" variant="outlined" name="userName" value={userInfo && userInfo.userName} label="ユーザー名" size="small" disabled multiline />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl required className={classes.mWidth} margin="dense" variant="outlined" error={form.currentpassword.length === 0 ? true : errmsg.length !== 0}>
                <InputLabel htmlFor="currentpassword">現在のパスワード</InputLabel>
                <OutlinedInput id="currentpassword" label="現在のパスワード" name="currentpassword" type={show.current ? 'text' : 'password'} value={form.currentpassword} onChange={handleChangeForm}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="current password visibility"
                        onClick={handleClickCurrentPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {show.current ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {!form.currentpassword && <FormHelperText error>必須項目です</FormHelperText>}
                {errmsg && <FormHelperText error>{errmsg}</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl required className={classes.mWidth} margin="dense" variant="outlined" error={form.changepassword.length === 0 ? true : passwordc}>
                <InputLabel htmlFor="changepassword">変更後のパスワード</InputLabel>
                <OutlinedInput id="changepassword" label="変更後のパスワード" name="changepassword" type={show.change ? 'text' : 'password'} value={form.changepassword} onChange={handleChangeForm}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="change password visibility"
                        onClick={handleClickChangePassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {show.change ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {!form.changepassword && <FormHelperText error>必須項目です</FormHelperText>}
                {passwordc && <FormHelperText error>8文字以上の半角英数字で入力してください</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl required className={classes.mWidth} margin="dense" variant="outlined" error={form.checkpassword.length === 0 ? true : checkChange}>
                <InputLabel htmlFor="checkpassword">パスワードの確認</InputLabel>
                <OutlinedInput id="checkpassword" label="パスワードの確認" name="checkpassword" type={show.check ? 'text' : 'password'} value={form.checkpassword} onChange={handleChangeForm}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="check password visibility"
                        onClick={handleClickCheckPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {show.check ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  } />
                {!form.checkpassword && <FormHelperText error>必須項目です</FormHelperText>}
                {checkChange && <FormHelperText>パスワードが一致しません</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" direction="column" alignItems="center">
                <Grid item>
                  <div className={classes.wrapper}>
                    <Button variant="contained" color="primary" size="large"
                      className={classes.button}
                      disabled={allCheck}
                      onClick={handleClickOpen}>
                      変更
                    </Button>
                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                  </div>
                </Grid>
                <Grid item>
                  {allCheck && !loading && <Typography color='error' variant="caption">{`未入力の必須項目かエラーがあります`}</Typography>}
                </Grid>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </form>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" ><div className={classes.dialogtitle}><WarningIcon />{" パスワードを変更します"}</div></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            パスワードを変更すると登録されている全てのユーザーに影響します。また、登録されているユーザーに、変更をした旨のメールが送られます。
          </DialogContentText>
          <DialogContentText style={{ color: 'red', textDecoration: 'underline' }}>本当に変更しますか？</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus >
            いいえ
          </Button>
          <Button onClick={onSubmit} color="primary">
            はい
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment >
  )
}

export default PasswordSettingForm